import React, { useEffect } from "react";
import { Row, Form } from "react-bootstrap";
import { useGlobalState } from '../../components/globalStateProvider';

const SNMachineListStats = ({ index, block }) => {
  const { statsBlocks, updateStatsBlock } = useGlobalState();

  // Reset SN se cambia la customer o machine family
  useEffect(() => {
    updateStatsBlock(index, "snMachine", "");
  }, [block.customerName, block.machineFamily]);

  return (
    <Row className="text-center mt-2 mb-2">
      <Form.Select
        value={block.snMachine || ""}
        onChange={e => updateStatsBlock(index, "snMachine", e.target.value)}
      >
        <option value="" disabled>Seleziona una matricola macchina</option>
        {block.listSNMachines.map((sn, i) => (
          <option value={sn} key={i}>{sn}</option>
        ))}
      </Form.Select>
    </Row>
  );
};

export default SNMachineListStats;
